<template>
  <span ref="root" class="brand-livery" :class="{ 'brand-livery--in': revealed }"
    >{{ name }}<span class="brand-livery__dot" :style="{ color: accent }">.</span
    ><span class="brand-livery__tail"
      ><span
        v-for="(ch, i) in letters"
        :key="i"
        class="brand-livery__letter group-hover:animate-livery-stretch motion-reduce:animate-none"
        :style="{
          transitionDelay: `${0.25 + i * 0.07}s`,
          animationDelay: `${(letters.length - 1 - i) * 0.12}s`,
          animationDuration: `${0.76 - (letters.length - 1 - i) * 0.12}s`,
          '--shift': i + 1,
        }"
        >{{ ch }}</span
      ></span
    ></span
  >
</template>

<script setup>
import { computed } from 'vue';

import { useInView } from '@/composables/useInView';

const props = defineProps({
  name: { type: String, required: true },
  tail: { type: String, required: true },
  accent: { type: String, required: true },
});

const letters = computed(() => [...props.tail]);
const { target: root, inView: revealed } = useInView();
</script>

<style scoped lang="scss">
.brand-livery__dot {
  display: inline-block;
  transform: scale(0);
  transition: transform 0.45s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.brand-livery__tail {
  @apply text-gray-400 dark:text-primary-light;

  display: inline-block;
}

.brand-livery__letter {
  display: inline-block;
  opacity: 0;
  transform: translateX(0.5em);
  transition:
    opacity 0.4s ease,
    transform 0.4s cubic-bezier(0.2, 0.8, 0.2, 1);
}

.brand-livery--in {
  .brand-livery__dot {
    transform: scale(1);
  }

  .brand-livery__letter {
    opacity: 1;
    transform: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .brand-livery__dot,
  .brand-livery__letter {
    transition: none;
  }
}
</style>
